import React from 'react';
import css from './index.scss';

const Spinner = () => (
    <div className={css.loadingContainer}>
        <div className={css.loadingIcon}>
            <div className={`${css.loader} ${css.loaderSpeed}`} />
        </div>
    </div>
);


export default Spinner;



// WEBPACK FOOTER //
// ./app/components/spinner/index.js